import { Nullable } from '@shared/types/dev';

export class Destinataire {
  id: number;
  principal: boolean = false;
  destinataire: string;
  echeance: string;
  date: string;
  dateEcheance: string;
  demandeur: string;
  action: string;
  reponse: string;
  type: string;
  contactId: number;
  contactIdiAdmin: number;
  libre: string;
  name: string;
  nom: string;
  prenom: string;
  accuseDeReponse: boolean;
  canBeTransformInAction: boolean;
  fontBold: boolean;
  foreColor: string;
  groupeId: null;
  isAction: boolean;
  isService: boolean;
  mailId: number;
  message: Nullable<string>;
  serviceDestinataireId: Nullable<number>;
  serviceId: Nullable<number>;
  serviceProprietaireId: Nullable<number>;
  statut: Nullable<string>;
  traiteLe: Nullable<Date>;
  transmisDate: Nullable<Date>;
  transmissionUserId: Nullable<number>;

  constructor(data: any) {
    Object.assign(this, data);
    this.name = this.nom + ' ' + this.prenom;
  }
}
